import React, { useState } from "react";
import Modal from "react-modal/lib/components/Modal";
import { IndexHooks } from "./hook";
import "./style.css";
import "../../../../style/form-register.css";
import { BtnSubmit } from "../../../button/button-submit/button-submit";
import { BtnBack } from "../../../button/button-back";
import libForm from "../../../../util/libForm";
import Loading from "../../../loading";
import HeaderRegister from "../../../header/register";
import CurrencyInput from "../../../inputs/currency";
import TextInput from "../../../inputs/text";
import MaskInput from "../../../inputs/mask";
import ModalMain from "../../../../components/modal";
import Form from "../../../../pages/register/client-type/form";
import SelectInput from "../../../inputs/select";
import { BtnCustom } from "../../../button/button";

export const ModalRegisterClient = () => {
	const {
		//hook form
		errors,
		isSubmitting,
		register,
		setValue,
		control,
		handleSubmit,
		handleOnSubmit,

		//Data
		citiesData,
		clientTypeData,

		//variaveis de estado
		loading,
		loadingCities,
		cepIsSubmitting,

		//context
		isOpenModalRegisterClient,
		brazilStates,

		//funções
		handleSelectedState,
		handleFetchAddress,
		insertTypeClient,
		reloadTypeClient,
		handleCloseModal,
	} = IndexHooks();

	const [options] = useState({ ident: "TypeClient" });

	const handleOpenRegisterTypeClient = (e) => {
		e.preventDefault();
		const event = new CustomEvent(options.ident);
		window.dispatchEvent(event);
	};

	const handleCloseModalTypeClient = () => {
		reloadTypeClient();
	};

	return (
		<>
			<Modal
				isOpen={isOpenModalRegisterClient}
				onRequestClose={handleCloseModal}
				overlayClassName="modal-overlay-register"
				className="modal-content-form modal-resize"
				shouldCloseOnOverlayClick={false}
			>
				<div className="container-forms">
					<HeaderRegister
						title={"Cliente"}
						subTitle={"Cadastro de Cliente"}
						handleCloseModal={handleCloseModal}
					/>
					{loading ? (
						<div className="flex h-full">
							<Loading mensagem="Carregando..." />
						</div>
					) : (
						<form className="form" action="" onSubmit={handleSubmit(handleOnSubmit)}>
							<main className="px-2">
								<input id="id_cliente" {...register("id_cliente")} type="hidden" />
								<input id="id_funcionario" {...register("id_funcionario")} type="hidden" />

								<div className="row">
									<TextInput
										label="Nome"
										id="nome"
										placeholder=""
										register={register}
										errors={errors}
										onKeyDown={libForm.EnterTab}
										autoFocus={true}
										className="col-12 col-sm-12 col-lg-8 "
									/>

									<div className="check-box col-6 col-sm-6 col-lg-2 truncate gap-1">
										<input
											id="pessoafisica"
											type="checkbox"
											{...register("pessoafisica")}
											onKeyDown={(e) => libForm.EnterTab(e)}
										/>
										<label className="" htmlFor="pessoafisica">
											Pessoa Física
										</label>
									</div>

									<div className={`check-box col-6 col-sm-6 col-lg-2 justify-center`}>
										<div className="check-input">
											<input
												className={`${errors.ativo ? "error" : ""}`}
												id="ativo"
												type="checkbox"
												{...register("ativo")}
												onKeyDown={(e) => libForm.EnterTab(e)}
											/>
											<label htmlFor="ativo">Ativo</label>
										</div>
									</div>

									<MaskInput
										label="Cep"
										name="cep"
										control={control}
										errors={errors}
										format="#####-###"
										className="col-4 col-sm-4 col-lg-2"
										onKeyDown={libForm.EnterTab}
									/>

									<div className="col-8 d-flex align-items-center">
										<BtnCustom
											className="btn btn-sm btn-outline-primary btn-cep"
											onClick={(e) => handleFetchAddress()}
											onKeyDown={(e) => libForm.EnterTab(e)}
											text={cepIsSubmitting ? "Buscando..." : "Buscar endereço por CEP"}
										/>
									</div>

									<TextInput
										label="Endereço"
										id="rua"
										placeholder=""
										register={register}
										errors={errors}
										onKeyDown={libForm.EnterTab}
										className="col-12 col-sm-8 col-lg-5"
									/>
									<TextInput
										label="Número"
										id="numero"
										placeholder=""
										register={register}
										errors={errors}
										onKeyDown={libForm.EnterTab}
										className="col-4 col-sm-4 col-lg-2"
									/>
									<TextInput
										label="Complemento"
										id="complemento"
										placeholder=""
										register={register}
										errors={errors}
										onKeyDown={libForm.EnterTab}
										className="col-8 col-sm-6 col-lg-2"
									/>
									<TextInput
										label="Bairro"
										id="bairro"
										placeholder=""
										register={register}
										errors={errors}
										onKeyDown={libForm.EnterTab}
										className="col-12 col-sm-6 col-lg-3"
									/>
									<SelectInput
										label="Estado"
										id="uf"
										labelSelect="nome"
										control={control}
										errors={errors}
										data={brazilStates}
										setValue={setValue}
										onKeyDown={libForm.EnterTab}
										handleSelect={handleSelectedState}
										loading={loadingCities}
										className="col-12 col-sm-6 col-lg-4"
									/>
									<SelectInput
										label="Cidade"
										id="id_cidade"
										labelSelect="nome"
										control={control}
										errors={errors}
										data={citiesData}
										setValue={setValue}
										onKeyDown={libForm.EnterTab}
										loading={loadingCities}
										className="col-12 col-sm-6 col-lg-4"
									/>

									<div className="input-select-box d-flex flex-column col-12 col-sm-6 col-lg-4">
										<label htmlFor="id_tipocliente">Tipo Cliente</label>
										<select
											{...register("id_tipocliente", {
												setValueAs: (value) => parseInt(value, 10),
											})}
											defaultValue=""
											onChange={(e) => {
												// handleCategoryChange(e);
												register("id_tipocliente").onChange(e);
											}}
											onKeyDown={(e) => libForm.EnterTab(e)}
										>
											<option value="" disabled>
												Selecione um tipo
											</option>
											{clientTypeData?.map((clientType) => (
												<option
													key={clientType.id_tipocliente}
													value={clientType.id_tipocliente}
												>
													{clientType.nome}
												</option>
											))}
										</select>
										{errors.id_tipocliente && <p>{errors.id_tipocliente.message}</p>}
										<div className="flex h-4 justify-end">
											<button
												type="button"
												className="flex btn btn-success items-center text-xs"
												onClick={handleOpenRegisterTypeClient}
												onKeyDown={(e) => libForm.EnterTab(e)}
											>
												Cadastrar Tipo
											</button>
										</div>
									</div>

									<div className="col-12 col-sm-6 col-lg-4 input-box">
										<label htmlFor="telefone_1">Celular</label>
										<input
											className={`${errors.telefone_1 ? "error" : ""}`}
											id="telefone_1"
											{...register("telefone_1")}
											type="text"
											placeholder="Celular"
											onKeyDown={(e) => libForm.EnterTab(e)}
											maxLength={14}
										/>
										{errors.telefone_1 && <p className="errors">{errors.telefone_1.message}</p>}
									</div>

									<div className="col-12 col-sm-6 col-lg-4 input-box">
										<label htmlFor="telefone_2">Telefone</label>
										<input
											className={`${errors.telefone_2 ? "error" : ""}`}
											id="telefone_2"
											{...register("telefone_2")}
											type="text"
											placeholder="Telefone"
											onKeyDown={(e) => libForm.EnterTab(e)}
											maxLength={14}
										/>
										{errors.telefone_2 && <p className="errors">{errors.telefone_2.message}</p>}
									</div>

									<div className="col-12 col-sm-6 col-lg-4 input-box">
										<label htmlFor="cpf">CPF/Cnpj</label>
										<input //
											className={`${errors.cpf ? "error" : ""}`}
											id="cpf"
											{...register("cpf")}
											type="text"
											placeholder="Cpf"
											onKeyDown={(e) => libForm.EnterTab(e)}
										/>
										{errors.cpf && <p className="errors">{errors.cpf.message}</p>}
									</div>

									<div className="col-12 col-sm-6 col-lg-4 input-box">
										<label htmlFor="rg">RG</label>
										<input //
											className={`${errors.rg ? "error" : ""}`}
											id="state"
											{...register("rg")}
											type="text"
											placeholder="Rg"
											onKeyDown={(e) => libForm.EnterTab(e)}
										/>
										{errors.rg && <p className="errors">{errors.rg.message}</p>}
									</div>

									<div className="input-select-box d-flex flex-column col-6 col-sm-6 col-lg-4">
										<label htmlFor="">Estado Civil</label>
										<select
											{...register("estadocivil")}
											defaultValue=""
											onKeyDown={(e) => libForm.EnterTab(e)}
										>
											<option value="" disabled hidden>
												Selecione uma opção
											</option>
											<option value="CASADO(A)">CASADO(A)</option>
											<option value="AMAZIADO(A)">AMAZIADO(A)</option>
											<option value="SOLTEIRO(A)">SOLTEIRO(A)</option>
											<option value="DIVORCIADO(A)">DIVORCIADO(A)</option>
											<option value="VIUVO(A)">VIUVO(A)</option>
										</select>
										{errors.estadocivil && <p className="errors">{errors.estadocivil.message}</p>}
									</div>
									<div className="input-select-box d-flex flex-column col-6 col-sm-6 col-lg-4">
										<label htmlFor="">Escolaridade</label>
										<select
											{...register("escolaridade")}
											defaultValue=""
											onKeyDown={(e) => libForm.EnterTab(e)}
										>
											<option value="" disabled hidden>
												Selecione uma opção
											</option>
											<option value="1º GRAU">1º GRAU</option>
											<option value="1º GRAU INCOMPLETO">1º GRAU INCOMPLETO</option>
											<option value="2º GRAU">2º GRAU</option>
											<option value="2º GRAU INCOMPLETO">2º GRAU INCOMPLETO</option>
											<option value="SUPERIOR">SUPERIOR</option>
											<option value="SUPERIOR INCOMPLETO">SUPERIOR INCOMPLETO</option>
										</select>
										{errors.escolaridade && <p className="errors">{errors.escolaridade.message}</p>}
									</div>
									<div className="input-select-box d-flex flex-column col-6 col-sm-6 col-lg-4">
										<label htmlFor="">Status</label>
										<select
											{...register("status")}
											defaultValue=""
											onKeyDown={(e) => libForm.EnterTab(e)}
										>
											<option value="" disabled hidden>
												Selecione uma opção
											</option>
											<option value="VER">VERDE</option>
											<option value="AMA">AMARELO</option>
											<option value="VEM">VERMELHO</option>
										</select>
										{errors.status && <p className="errors">{errors.status.message}</p>}
									</div>

									<CurrencyInput
										label="Valor Limite de Crédito"
										name="limitevale"
										control={control}
										errors={errors}
										placeholder="Digite o preço"
										required={true}
										decimalScale={2}
										prefix="R$ "
										className={`col-6 col-sm-6 col-lg-2`}
										onKeyDown={libForm.EnterTab}
										truncate={true}
									/>

									<TextInput
										label="E-mail"
										id="email_contato"
										placeholder=""
										register={register}
										errors={errors}
										onKeyDown={libForm.EnterTab}
										className="col-12 col-sm-6 col-lg-6"
									/>
									<TextInput
										label="Observações"
										id="obs"
										placeholder=""
										register={register}
										errors={errors}
										className="col-12 col-sm-6 col-lg-6"
									/>
								</div>
							</main>
							<footer>
								<BtnBack onClick={handleCloseModal} isSubmitting={isSubmitting} />

								<BtnSubmit isSubmitting={isSubmitting} />
							</footer>
						</form>
					)}
				</div>
			</Modal>
			<ModalMain ident={options.ident}>
				<HeaderRegister title="Tipo de Cliente" subTitle="Cadastro de tipo de cliente" />
				<Form
					idTable={0}
					selectedData={[]}
					reloadData={handleCloseModalTypeClient}
					insert={insertTypeClient}
					ident={options.ident}
				/>
			</ModalMain>
		</>
	);
};

// //state
// loading,
// cepIsSubmitting,
// clientTypeData,

// handleSelectedState,

// //context
// isOpenModalRegisterClient,
// citiesData,

// //hook form
// errors,
// control,
// isSubmitting,
// register,
// handleSubmit,

// //functions
// handleOnSubmit,
// handleFetchAddress,
// handleCloseModal,
// reloadTypeClient,
// insertTypeClient,
